<div class="maintenance-mode-page">
    <div class="maintenance-mode-page__container" [innerHTML]="contentText">
    </div>
</div>